const SESSION_STORAGE_KEY = 'preserve-url-params-password-page';

function pushUrlParamsToSessionStorage() {
  const { search } = window.location;

  // This prevents the session storage entry from being overwritten on language switch.
  if (!search) return;

  const urlParams = new URLSearchParams(window.location.search);

  window.sessionStorage.setItem(SESSION_STORAGE_KEY, urlParams.toString());
}

function setUrlParamsFromSessionStorage() {
  const urlParams = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

  if (urlParams) {
    // Get the current URL params.
    const currentUrlParams = new URLSearchParams(window.location.search);

    // Merge the current URL params with the URL params from the session storage.
    const mergedUrlParams = new URLSearchParams(urlParams);
    currentUrlParams.forEach((value, key) => {
      mergedUrlParams.set(key, value);
    });

    // Set the URL params.
    window.location.search = `?${mergedUrlParams.toString()}`;

    // Clear the session storage to prevent the URL params from being set again
    // on subsequent page loads.
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  }
}

if (window.location.pathname.endsWith('/password')) {
  pushUrlParamsToSessionStorage();
} else {
  setUrlParamsFromSessionStorage();
}
